import React, { CSSProperties } from "react";
import { IconColor, IconName, iconMap } from "./IconMap";
import cx from "classnames";
import { useButtonVariant } from "../ThemeProvider/useButtonVariant";
import { DesignSystemVariant } from "../ThemeProvider/ThemeProvider.provider";

export type IconSize =
  | "2xs"
  | "xs"
  | "sm"
  | "md"
  | "lg"
  | "xl"
  | "xl+"
  | "2xl"
  | "3xl"
  | "custom";

export default function Icon({
  iconName,
  label,
  size = "sm",
  className,
  strokeWidth,
  color = "inherit",
  overrideSize = false,
  style,
  iconWrapperClassName,
}: {
  iconName: IconName;
  label?: string;
  size?: IconSize;
  className?: string;
  strokeWidth?: number;
  color?: IconColor;
  overrideSize?: boolean;
  style?: CSSProperties;
  iconWrapperClassName?: string;
}) {
  const IconComponent = iconMap[iconName];
  const buttonVariant: DesignSystemVariant = useButtonVariant();
  const isEnterprise = buttonVariant === "enterprise";
  return (
    <i
      className={cx(
        {
          "inline-block": !iconWrapperClassName,
        },
        iconWrapperClassName
      )}
    >
      {IconComponent ? ( // TODO: look into adding lazy loading of icons
        <IconComponent
          strokeWidth={strokeWidth}
          aria-label={label}
          aria-hidden={!label}
          className={cx(
            "inline-block",
            {
              "w-4 h-4": !overrideSize && size === "2xs",
              "w-5 h-5": !overrideSize && size === "xs",
              "w-6 h-6": !overrideSize && size === "sm",
              "w-8 h-8": !overrideSize && size === "md",
              "w-10 h-10": !overrideSize && size === "lg",
              "w-12 h-12": !overrideSize && size === "xl",
              "w-18 h-18": !overrideSize && size === "xl+",
              "w-28 h-28": !overrideSize && size === "2xl",
              "w-72 h-72": !overrideSize && size === "3xl",
              "text-white": color === "white",
              "text-black": color === "black",
              "text-saphire": color === "saphire",
              "text-ocean-500": color === "ocean",
              "text-orange": color === "orange",
              "text-green": color === "green" && !isEnterprise,
              "text-emerald-700": color === "green" && isEnterprise,
              "text-red": color === "red",
              "text-neutral-500": color === "neutral-light",
              "text-neutral-600": color === "neutral",
              "text-neutral-700": color === "neutral-dark",
              "text-inherit": color === "inherit",
            },
            className
          )}
          style={style}
        />
      ) : null}
    </i>
  );
}
